Namespace 'Customer.Ticket'

class Customer.Ticket.WebchatHistoryMessageView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/webchat/webchat_history_message']
  className: 'wh-message'

  initialize: ({historyMessage}) ->
    @historyMessage = historyMessage
    @historyMessage['attributes']['text'] = DOMPurify.sanitize(@historyMessage['attributes']['text'])

  render: ->
    @$el.addClass "wh-message-#{@historyMessage.source()}"
    @$el.html @template
      message: @historyMessage
      avatarSrc: @_avatarSrc()
    @

  _avatarSrc: ->
    if @historyMessage.source() is 'foreign' then 'chat-brand.png' else 'webchat-start.png'
